import {
  MigrationProgress,
  ProvisionSupportUserQueryResponse,
  Region,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/workflows_pb";

import { RegionCode } from "types/region";

// https://docs.temporal.io/visibility#default-search-attributes - ExecutionStatus
export enum WorkflowStatus {
  CANCELED = "Canceled",
  CONTINUEDASNEW = "ContinuedAsNew",
  COMPLETED = "Completed",
  FAILED = "Failed",
  RUNNING = "Running",
  TERMINATED = "Terminated",
  TIMEDOUT = "TimedOut",
}

export const ToMigrationRegion = (region: string | RegionCode) => {
  switch (region) {
    case "au":
      return Region.AP_SOUTHEAST_2;
    case "eu":
      return Region.EU_WEST_1;
    case "us":
      return Region.US_EAST_1;
    default:
      return Region.UNSPECIFIED;
  }
};

export type MigrationStatus = MigrationProgress;
export type ProvisionSupportUserStatus = ProvisionSupportUserQueryResponse;
